module.exports = __webpack_public_path__ + "img/5.a414861c.webp";